<textarea
  #textarea
  [class.textarea-autosize]="textareaAutosize"
  [class]="theme"
  [value]="value"
  [id]="uniqueId"
  [cdkTextareaAutosize]="textareaAutosize"
  [cdkAutosizeMinRows]="minRows"
  [cdkAutosizeMaxRows]="maxRows"
  [placeholder]="placeholder"
  [spellcheck]="spellcheck"
  [disabled]="disabled"
  (input)="save($event.target.value)"
  (blur)="onTouched($event.target.value)"
></textarea>
